module.exports = __webpack_public_path__ + "static/img/android-download.0c431a66.png";